// client/extensions/CodeBlock/CodeBlock.ts
import { CodeBlockLowlight } from "@tiptap/extension-code-block-lowlight";
import { common, createLowlight } from "lowlight";
import "./theme.css";
var lowlight = createLowlight(common);
var lowlightCodeblock = CodeBlockLowlight.configure({
  lowlight,
  defaultLanguage: "typescript",
  HTMLAttributes: { class: "hljs", style: "padding: 8px" }
});
var CodeBlock = {
  extensions: [lowlightCodeblock]
  // styles: () => [css],
};
export {
  CodeBlock
};
